import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Box } from '@material-ui/core';
import { Colors } from '../../helpers/theme';
import StepperConnector from "../../assets/images/StepperConnector.svg"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contributeStepper: {
      width: '50%',
      '& .MuiStep-horizontal':{
        paddingLeft:0,
        paddingRight:0
      },
      '& .MuiStepLabel-iconContainer':{
        paddingRight:theme.spacing(0),
        '& .MuiStepIcon-root':{
          color:Colors.aliceblue,
          border:"none",
        },
        '& .MuiStepIcon-completed':{
          color:Colors.green,
        }, 
        '& .MuiStepIcon-root.MuiStepIcon-active':{
          color:Colors.aliceblue
        }
      }
    },
  }),
);

function getSteps() {
  return ['', ''];
}



export default function HorizontalLabelPositionBelowStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(-1);
  const steps = getSteps();

  const ConnectorIcon = () => {
    return (
      <img src={StepperConnector} className="img-fluid " alt="gains" />
    );
  };

  

  return (
    <Box className={classes.contributeStepper} >
      <Stepper activeStep={activeStep}  connector={<ConnectorIcon />} >
        {steps.map((label) => (
          <Step key={label} onClick={() => alert("hello")}>
           
            <StepLabel className="stepperIcon"  >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
   
    </Box>
  );
}